// One opening of the link per visit: every ack-start consumes one of the few openings the tenant allows
// (max_ack_token_uses). The ack-start result of this visit is kept in the TAB (sessionStorage: per tab, dropped
// when the tab closes), bound to the end of the session, so a reload or a back navigation during the session
// shows the same page without calling ack-start again. Dropped as soon as the session is over.
// Once the convention is validated only { acknowledged, sessionEnd } is kept: a reload shows the confirmation
// alone, so the ack-start result (the user's marker or keyword included) is removed at once.

const PREFIX = 'hia-ack-visit:';

const storage = () => {
    try {
        return typeof window !== 'undefined' ? window.sessionStorage : null;
    } catch (e) {
        return null;
    }
};

const keyOf = (ackToken) => `${PREFIX}${ackToken}`;

export const clearVisit = (ackToken) => {
    const store = storage();
    if (!store) return;
    try {
        store.removeItem(keyOf(ackToken));
    } catch (e) {
        // Storage unavailable: nothing was kept.
    }
};

const toStored = (visit) => (visit.acknowledged
    ? { acknowledged: true, sessionEnd: visit.sessionEnd }
    : { convention: visit.convention, sessionEnd: visit.sessionEnd, acknowledged: false });

// A visit is kept only with a known session end (no end: ack-start is called again on reload).
export const saveVisit = (ackToken, visit) => {
    const store = storage();
    if (!store || !visit || !Number.isFinite(visit.sessionEnd)) {
        // An acknowledged visit that cannot be kept must not leave the convention behind.
        if (visit && visit.acknowledged) clearVisit(ackToken);
        return;
    }
    try {
        store.setItem(keyOf(ackToken), JSON.stringify(toStored(visit)));
    } catch (e) {
        // Storage full or blocked: the page still works, a reload will call ack-start again.
        if (visit.acknowledged) clearVisit(ackToken);
    }
};

export const loadVisit = (ackToken, now) => {
    const store = storage();
    if (!store) return null;
    let visit = null;
    try {
        visit = JSON.parse(store.getItem(keyOf(ackToken)) || 'null');
    } catch (e) {
        visit = null;
    }
    const usable = visit && (visit.acknowledged === true || !!visit.convention);
    if (!usable || !Number.isFinite(visit.sessionEnd) || visit.sessionEnd <= now) {
        clearVisit(ackToken);
        return null;
    }
    return visit;
};
